import SSBackgroundImage from "@core-components/backgroundImage/BackgroundImage";
import SSBgImageHeadline from "@core-components/backgroundImage/components/BgImageHeadline";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";

interface SkinHeroProps {
  skinName: string | undefined;
}

export const SkinHero = ({ skinName }: SkinHeroProps) => {
  const { t } = useAppTranslation("pages.skins.skin");

  return (
    <SSBackgroundImage>
      <SSBgImageHeadline
        props={{
          title: {
            order: 1,
          },
        }}
      >
        <SSWhiteText>{t("banner.titlePrefix")}</SSWhiteText>
        <br />
        <SSLoLGradientText>{skinName?.toUpperCase()}</SSLoLGradientText>
      </SSBgImageHeadline>
    </SSBackgroundImage>
  );
};
